module.exports = __webpack_public_path__ + "img/29.965f315e.jpg";